var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedalStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.4582 15.375C32.4582 17.8521 31.7236 20.1242 30.4594 22.0204C28.6144 24.7538 25.6932 26.6842 22.2936 27.1796C21.7128 27.2821 21.1148 27.3333 20.4998 27.3333C19.8848 27.3333 19.2869 27.2821 18.7061 27.1796C15.3065 26.6842 12.3853 24.7538 10.5403 22.0204C9.27609 20.1242 8.5415 17.8521 8.5415 15.375C8.5415 8.76374 13.8886 3.41666 20.4998 3.41666C27.1111 3.41666 32.4582 8.76374 32.4582 15.375Z",
    stroke: "#0C111D",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3019 31.5529L33.4832 32.2191C32.8511 32.3729 32.3557 32.8512 32.219 33.4833L31.6211 35.9946C31.2965 37.3612 29.554 37.7713 28.6486 36.695L20.4999 27.3333L12.3511 36.7121C11.4457 37.7883 9.70318 37.3783 9.3786 36.0116L8.78068 33.5004C8.62693 32.8683 8.13152 32.3729 7.51652 32.2362L4.69777 31.57C3.39943 31.2625 2.93818 29.6395 3.87777 28.7L10.5403 22.0375C12.3853 24.7708 15.3065 26.7013 18.7061 27.1967C19.2869 27.2992 19.8849 27.3504 20.4999 27.3504C21.1149 27.3504 21.7128 27.2992 22.2936 27.1967C25.6932 26.7013 28.6144 24.7708 30.4594 22.0375L37.1219 28.7C38.0615 29.6225 37.6003 31.2454 36.3019 31.5529Z",
    stroke: "#0C111D",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4909 10.2158L22.4988 12.2317C22.6355 12.505 22.9942 12.7783 23.3188 12.8296L25.1467 13.1371C26.3084 13.325 26.5817 14.1792 25.7446 15.0163L24.3267 16.4341C24.0875 16.6733 23.9509 17.1346 24.0363 17.4763L24.4463 19.2358C24.7709 20.6196 24.0363 21.1662 22.8063 20.4316L21.098 19.4237C20.7905 19.2358 20.278 19.2358 19.9705 19.4237L18.2621 20.4316C17.0321 21.1491 16.2975 20.6196 16.6221 19.2358L17.0321 17.4763C17.1005 17.1517 16.9809 16.6733 16.7417 16.4341L15.3238 15.0163C14.4867 14.1792 14.76 13.3421 15.9217 13.1371L17.7496 12.8296C18.0571 12.7783 18.4159 12.505 18.5525 12.2317L19.5605 10.2158C20.0559 9.12251 20.9442 9.12251 21.4909 10.2158Z",
    stroke: "#FFD600",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedalStar);
export default __webpack_public_path__ + "static/media/medal-star.29bd1515dc790af971b726a333dedb7e.svg";
export { ForwardRef as ReactComponent };